import { TILE_SIZES } from './constants';

export default [
    {
        id: '2032',
        filterTiles: [
            {
                id: 'db_type',
                tilesOrder: [
                    'mysql',
                    'ms_sql',
                    'access',
                    'oracle',
                    'sqlite',
                    'postgres',
                    'mongo',
                    'teradata'
                ]
            }
        ]
    },
    {
        id: '2031',
        filterTiles: [
            {
                id: 'db_type',
                tilesOrder: [
                    'mysql',
                    'ms_sql',
                    'access',
                    'oracle',
                    'sqlite',
                    'postgres',
                    'mongo',
                    'teradata'
                ]
            }
        ]
    },
    {
        id: '2030',
        filterTiles: [
            {
                id: 'db_type',
                tilesOrder: [
                    'mysql',
                    'ms_sql',
                    'access',
                    'oracle',
                    'sqlite',
                    'postgres',
                    'mongo',
                    'teradata'
                ]
            }
        ]
    },
    {
        id: '386',
        filterTiles: [
            {
                id: 'podcast_cover_style',
                tilesOrder: [
                    'photographic',
                    'illustrative',
                    'typographic'
                ]
            }
        ]
    },
    {
        id: '50',
        filterTiles: [
            {
                id: 'illustration_style',
                tileSize: TILE_SIZES.LARGE,
                tilesOrder: [
                    'for_children',
                    'realistic_drawing',
                    'comic_cartoon',
                    'manga',
                    'flat',
                    'line_art',
                    'sketch'
                ]
            },
            {
                id: 'artistic_technique',
                tileSize: TILE_SIZES.LARGE,
                tilesOrder: [
                    'freehand_digital',
                    'vector_art',
                    'mixed_media',
                    'pen_ink',
                    'watercolor',
                    'pencil'
                ]
            }
        ]
    },
    {
        id: '420',
        filterTiles: [
            {
                id: 'design_technique',
                tilesOrder: [
                    'digital',
                    'hand_drawn'
                ]
            },
            {
                id: 'design_style',
                tilesOrder: [
                    'abstract',
                    'cartoon',
                    'realistic',
                    'seasonal',
                    'collage'
                ]
            }
        ]
    },
    {
        id: '2319',
        filterTiles: [
            {
                id: 'design_style',
                tilesOrder: [
                    'illustrative',
                    'photographic',
                    'typographic'
                ]
            }
        ]
    },
    {
        id: '2318',
        filterTiles: [
            {
                id: 'design_style',
                tilesOrder: [
                    'illustrative',
                    'photographic',
                    'typographic'
                ]
            }
        ]
    },
    {
        id: '392',
        filterTiles: [
            {
                id: 'genre',
                tilesOrder: [
                    'pop',
                    'hip_hop',
                    'rap',
                    'r_b',
                    'edm'
                ]
            }
        ]
    },
    {
        id: '156',
        filterTiles: [
            {
                id: 'instrument',
                tilesOrder: [
                    'guitar',
                    'drums',
                    'bass',
                    'piano',
                    'keyboards'
                ]
            }
        ]
    },
    {
        id: '235',
        filterTiles: [
            {
                id: 'animation_type',
                tilesOrder: [
                    '2d',
                    '3d'
                ]
            }
        ]
    },
    {
        id: '384',
        filterTiles: [
            {
                id: 'language',
                tilesOrder: [
                    'english',
                    'spanish',
                    'french',
                    'german',
                    'arabic'
                ]
            }
        ]
    },
    {
        id: '249',
        filterTiles: [
            {
                id: 'type',
                tilesOrder: [
                    'weddings_events',
                    'family_travel',
                    'corporate',
                    'sports_games',
                    'elearning'
                ]
            }
        ]
    },
    {
        id: '334',
        filterTiles: [
            {
                id: 'language',
                tilesOrder: [
                    'english',
                    'german',
                    'french',
                    'italian',
                    'spanish'
                ]
            }
        ]
    },
    {
        id: '1029',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'wix',
                    'squarespace',
                    'godaddy',
                    'sitebuilder',
                    'webflow'
                ]
            }
        ]
    },
    {
        id: '1006',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'wix',
                    'squarespace',
                    'godaddy',
                    'sitebuilder',
                    'webflow'
                ]
            }
        ]
    },
    {
        id: '1005',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'wix',
                    'squarespace',
                    'godaddy',
                    'sitebuilder',
                    'webflow'
                ]
            }
        ]
    },
    {
        id: '1004',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'wix',
                    'squarespace',
                    'godaddy',
                    'sitebuilder',
                    'webflow'
                ]
            }
        ]
    },
    {
        id: '1003',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'wix',
                    'squarespace',
                    'godaddy',
                    'sitebuilder',
                    'webflow'
                ]
            }
        ]
    },
    {
        id: '1001',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'wix',
                    'squarespace',
                    'godaddy',
                    'sitebuilder',
                    'webflow'
                ]
            }
        ]
    },
    {
        id: '1002',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'wix',
                    'squarespace',
                    'godaddy',
                    'sitebuilder',
                    'webflow'
                ]
            },
            {
                id: 'spcecialization',
                tilesOrder: [
                    'blog_magazine',
                    'corporate',
                    'education',
                    'portfolio',
                    'entertainment',
                    'wedding'
                ]
            }
        ]
    },
    {
        id: '1000',
        filterTiles: [
            {
                id: 'spcecialization',
                tilesOrder: [
                    'blog_magazine',
                    'corporate',
                    'education',
                    'portfolio',
                    'entertainment',
                    'wedding'
                ]
            },
            {
                id: 'platform',
                tilesOrder: [
                    'wix',
                    'squarespace',
                    'godaddy',
                    'sitebuilder',
                    'webflow'
                ]
            }
        ]
    },
    {
        id: '1019',
        filterTiles: [
            {
                id: 'spcecialization',
                tilesOrder: [
                    'blog',
                    'business',
                    'education',
                    'portfolio',
                    'entertainment',
                    'wedding'
                ]
            }
        ]
    },
    {
        id: '1007',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'shopify',
                    'woocommerce',
                    'magento',
                    'prestashop',
                    'opencart',
                    'bigcommerce'
                ]
            }
        ]
    },
    {
        id: '1008',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'shopify',
                    'woocommerce',
                    'magento',
                    'prestashop',
                    'opencart',
                    'bigcommerce'
                ]
            }
        ]
    },
    {
        id: '1009',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'shopify',
                    'woocommerce',
                    'magento',
                    'prestashop',
                    'opencart',
                    'bigcommerce'
                ]
            }
        ]
    },
    {
        id: '1010',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'shopify',
                    'woocommerce',
                    'magento',
                    'prestashop',
                    'opencart',
                    'bigcommerce'
                ]
            }
        ]
    },
    {
        id: '1011',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'shopify',
                    'woocommerce',
                    'magento',
                    'prestashop',
                    'opencart',
                    'bigcommerce'
                ]
            }
        ]
    },
    {
        id: '1012',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'shopify',
                    'woocommerce',
                    'magento',
                    'prestashop',
                    'opencart',
                    'bigcommerce'
                ]
            }
        ]
    },
    {
        id: '1013',
        filterTiles: [
            {
                id: 'platform',
                tilesOrder: [
                    'shopify',
                    'woocommerce',
                    'magento',
                    'prestashop',
                    'opencart',
                    'bigcommerce'
                ]
            }
        ]
    },
    {
        id: '2405',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'shopify',
                    'amazon',
                    'ebay',
                    'etsy',
                    'woocommerce'
                ]
            }
        ]
    },
    {
        id: '2151',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'shopify',
                    'amazon',
                    'ebay',
                    'etsy',
                    'woocommerce'
                ]
            }
        ]
    },
    {
        id: '2307',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'facebook',
                    'instagram',
                    'youtube',
                    'linkedin'
                ]
            }
        ]
    },
    {
        id: '2308',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'facebook',
                    'instagram',
                    'youtube',
                    'linkedin'
                ]
            }
        ]
    },
    {
        id: '2309',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'facebook',
                    'instagram',
                    'youtube',
                    'linkedin'
                ]
            }
        ]
    },
    {
        id: '54',
        filterTiles: [
            {
                id: 'purpose',
                tilesOrder: [
                    'marketing',
                    'investor_pitch_fundraising',
                    'business_proposal',
                    'education_training',
                    'sales',
                    'conference'
                ]
            }
        ]
    },
    {
        id: '2060',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'facebook',
                    'instagram',
                    'linkedin',
                    'twitter',
                    'youtube'
                ]
            }
        ]
    },
    {
        id: '2061',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'facebook',
                    'instagram',
                    'linkedin',
                    'twitter',
                    'youtube'
                ]
            }
        ]
    },
    {
        id: '2062',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'facebook',
                    'instagram',
                    'linkedin',
                    'twitter',
                    'youtube'
                ]
            }
        ]
    },
    {
        id: '2063',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'facebook',
                    'instagram',
                    'linkedin',
                    'twitter',
                    'youtube'
                ]
            }
        ]
    },
    {
        id: '2065',
        filterTiles: [
            {
                id: 'platform_type',
                tilesOrder: [
                    'facebook',
                    'instagram',
                    'linkedin',
                    'twitter',
                    'youtube'
                ]
            }
        ]
    },
    {
        id: '49',
        filterTiles: [
            {
                id: 'style',
                tileSize: TILE_SIZES.LARGE,
                tilesOrder: [
                    'flat_minimalist',
                    '3d',
                    'mascot_cartoon',
                    'signature',
                    'hand_drawn',
                    'retro',
                    'watercolor_feminine'
                ]
            }
        ]
    },
    {
        id: '371',
        filterTiles: [
            {
                id: 'asset_type',
                tilesOrder: [
                    'emotes_badges',
                    'overlays_screen_packs',
                    'panels',
                    'thumbnails',
                    'banners',
                    'alerts'
                ]
            }
        ]
    },
    {
        id: '99',
        filterTiles: [
            {
                id: 'service_type',
                tilesOrder: [
                    'ads_social_media_videos',
                    'corporate_videos',
                    'gaming_videos',
                    'family_videos',
                    'music_videos',
                    'explainer_videos',
                    'event_videos',
                    'showreels',
                    'fiction_films',
                    'movie_trailers',
                    'elearning',
                    'vr_360_video'
                ]
            }
        ]
    },
    {
        id: '16',
        filterTiles: [
            {
                id: 'language',
                tilesOrder: [
                    'english',
                    'german',
                    'french',
                    'arabic',
                    'italian',
                    'spanish'
                ]
            },
            {
                id: 'gender',
                tilesOrder: [
                    'female',
                    'male'
                ]
            }
        ]
    },
    {
        id: '163',
        filterTiles: [
            {
                id: 'language',
                tilesOrder: [
                    'english',
                    'spanish',
                    'french',
                    'german',
                    'italian',
                    'dutch'
                ]
            },
            {
                id: 'topic',
                tilesOrder: [
                    'internet_technology',
                    'health_medical',
                    'lifestyle',
                    'business_finance_law',
                    'beauty_fashion',
                    'marketing'
                ]
            }
        ]
    }
];
